import React from 'react';
import { Grid, Typography } from '@mui/material';
import { OpeningHoursSectionStyles } from '..';
import { useTranslation } from 'react-i18next';

export const OpeningHoursSectionTableHeader = () => {
  const { classes } = OpeningHoursSectionStyles();
  const { t } = useTranslation();
  return (
    <Grid container className={classes.mobileHeaderWrapper}>
      <Grid className={classes.headerTitleCol}>
        <Typography className={classes.title}>{t('settings.title.openingHours')}</Typography>
      </Grid>
    </Grid>
  );
};
